import React from "react";
import { MdKeyboardArrowRight } from "react-icons/md";
import { IoLogoNpm } from "react-icons/io";
import { BsGithub } from "react-icons/bs";
import { GrReactjs } from "react-icons/gr";
import { ImHtmlFive2 } from "react-icons/im";
import { DiCss3 } from "react-icons/di";
import { SiJavascript } from "react-icons/si";
import Styles from "../style.module.css";

function Services() {
  return (
    <div style={Styles.services_bg} className="pb-16">
      <h1 className="sm:ml-16 md:ml-[190px] my-16 uppercase font-bold text-2xl inline-block border-b border-second">
        XİDMƏTLƏR
      </h1>

      <div className="md:container md:mx-auto sm:gap-10 grid md:grid-cols-3 md:gap-4 min-h-[600px] ">
        <div className="service flex flex-col p-5 shadow-2xl gap-y-4 min-h-64 md:mx-0 sm:mx-16">
          <ImHtmlFive2 size={35} className="text-second" />
          <h1 className="font-semibold text-xl">Tikinti</h1>
          <p className="text-third">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore
            quis dignissimos iusto debitis quasi eveniet aliquam earum
            voluptatum quaerat dolore?
          </p>
          <button className="flex text-second ">
            Ətraflı
            <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
          </button>
        </div>

        <div className="service flex flex-col p-5 shadow-2xl gap-y-4 min-h-64 md:mx-0 sm:mx-16">
          <DiCss3 size={35} className="text-second" />
          <h1 className="font-semibold text-xl">Restavrasiya</h1>
          <p className="text-third">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore
            quis dignissimos iusto debitis quasi eveniet aliquam earum
            voluptatum quaerat dolore?
          </p>
          <button className="flex text-second ">
            Ətraflı
            <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
          </button>
        </div>

        <div className="service flex flex-col p-5 gap-y-4 shadow-2xl min-h-64 md:mx-0 sm:mx-16">
          <SiJavascript size={35} className="text-second" />
          <h1 className="font-semibold text-xl">Layihələndirmə</h1>
          <p className="text-third">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore
            quis dignissimos iusto debitis quasi eveniet aliquam earum
            voluptatum quaerat dolore?
          </p>
          <button className="flex text-second ">
            Ətraflı
            <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
          </button>
        </div>

        <div className="service flex flex-col p-5 shadow-2xl gap-y-4 min-h-64 md:mx-0 sm:mx-16">
          <GrReactjs size={35} className="text-first" />
          <h1 className="font-semibold text-xl">Texnikanın icarəsi</h1>
          <p className="text-third">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore
            quis dignissimos iusto debitis quasi eveniet aliquam earum
            voluptatum quaerat dolore?
          </p>
          <button className="flex text-second ">
            Ətraflı
            <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
          </button>
        </div>

        <div className="service flex flex-col  p-5 shadow-2xl gap-y-4 min-h-64 md:mx-0 sm:mx-16">
          <IoLogoNpm size={35} className="text-second" />
          <h1 className="font-semibold text-xl">Təmir</h1>
          <p className="text-third">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore
            quis dignissimos iusto debitis quasi eveniet aliquam earum
            voluptatum quaerat dolore?
          </p>
          <button className="flex text-second ">
            Ətraflı
            <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
          </button>
        </div>

        <div className="service flex flex-col p-5 gap-y-4 shadow-2xl min-h-64 md:mx-0 sm:mx-16">
          <BsGithub size={35} className="text-second" />
          <h1 className="font-semibold text-xl">
            Eksteryer və Landşaft dizaynı
          </h1>
          <p className="text-third">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore
            quis dignissimos iusto debitis quasi eveniet aliquam earum
            voluptatum quaerat dolore?
          </p>
          <button className="flex text-second ">
            Ətraflı
            <MdKeyboardArrowRight className="ml-3 mb-1 text-2xl" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Services;
